import { render, staticRenderFns } from "./Pane.vue?vue&type=template&id=edddc19e&"
import script from "./Pane.vue?vue&type=script&lang=js&"
export * from "./Pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports